<template>
  <Modal title="修改分数" v-model="visibleThis">
    <Form
      ref="editSalaryForm"
      class="form"
      :label-width="80"
      :complaintRow="attendanceRowThis"
      :model="attendanceRowThis"
    >
      <Row>
        <Col :span="22">
          <Row>
            <Form-item label="月份">
              <Input v-model="attendanceRowThis.createMonth" disabled></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="上课时间">
              <Input v-model="attendanceRowThis.lessonTime" disabled></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="老师姓名">
              <Input v-model="attendanceRowThis.tchName" disabled></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="请打分">
              <Input v-model="attendanceRowThis.score"></Input>
            </Form-item>
          </Row>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visibleThis = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingEditSalary"
        @click="editSalary"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'ModifyAttendanceScoreDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      attendanceRowThis: {},
    }
  },
  methods: {
    editSalary () {
      let self = this
      self.loadingEditSalary = true
      self.$http.post('/tch/lesson/update-score', this.attendanceRowThis).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('成功!')
          self.visibleThis = false
          self.loadingEditSalary = false
          self.successCallback()
        }
      }).catch(function (e) {
        self.loadingEditSalary = false
      })
    },
  },
  watch: {
    visible (val) {
      this.visibleThis = val
    },
    visibleThis (val) {
      if (!val) {
        this.attendanceRowThis = {}
        this.$emit('on-close', val)
      }
    },
    complaintRow (val) {
      this.attendanceRowThis = val
      if (this.attendanceRowThis.status === 0) {
        this.complaintRemarkList.forEach(item => {
          if (item.text === val.remark) {
            this.attendanceRowThis.stdNum = item.stdNum
            this.attendanceRowThis.tchNum = item.tchNum
            this.attendanceRowThis.subSalary = item.subSalary
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModifyAttendanceScoreDetailModal.vue?ab6a8c5e